module.exports = __webpack_public_path__ + "static/media/Metapod_gaussian2.9d2f7344.png";